export const PUBLIC_PHONE = "+971564707444";
export const WHATSAPP_NUMBER = "971564707444";
export const DEFAULT_WHATSAPP_MESSAGE = "Hi Silver Drive, I'd like to rent a car in Dubai.";

export const whatsappLink = (message = DEFAULT_WHATSAPP_MESSAGE) => (
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`
);